module.exports = __webpack_public_path__ + "static/img/business76.5a21b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business76.png
// module id = Cf7u
// module chunks = 9